import { getFormData } from 'app/utils/formUtils'
import { fileValidation } from 'app/utils/validationUtils'
import * as Yup from 'yup'
export type SponsorRequestContractSignFormData = {
  outcome_document_file?: FileList | null
}

export const sponsorRequestContractSignFormDefaultValues: SponsorRequestContractSignFormData =
  {
    outcome_document_file: null,
  }

export const sponsorRequestContractSignFormValidationSchema =
  Yup.object().shape({
    outcome_document_file: fileValidation({
      isRequired: true,
    }),
  })

export const adaptFormDataToAPI = (
  formData: SponsorRequestContractSignFormData
): FormData => getFormData({ formData: formData })
